module.exports = __webpack_public_path__ + "static/media/om.3ff0c074.svg";